import React from 'react';
import { addToWishListGA4 } from '../../../utils/gaFour';
import ColorOptions from './ColorOptions';
import FrameAnalysis from './FrameAnalysis';
import './ProductDetailNew.scss';

function setWishListCallLeft(props, ev) {
  const {
    shortListData,
    productId,
    productData,
    setWishList,
    setShortlistFull,
    shortListLoading,
    login,
  } = props;
  if (!shortListLoading) {
    if (shortListData.result.numberOfProducts < 50) {
      addToWishListGA4(productData, login);
      setWishList(productId, shortListData);
    } else if (ev.target.checked) {
      ev.target.checked = false;
      setShortlistFull();
    } else {
      setWishList(productId, shortListData);
    }
  }
}

function ProductDetailNew(props) {
  const {
    dataLocale,
    productData,
    currencyMark,
    productId,
    shortListData,
    isExchange,
    displayPrice,
    exchangeFreeText,
    exchangeText,
    frameShape,
    frameType,
    frameSize,
    getCmsPageData,
    cmsPopUpData,
    contactLensPowerFromUrl,
    shortListLoading,
    history,
    redisCommonData,
    login,
    userInfo,
    localeInfo,
    productPriceWithGst,
  } = props;
  const { frameColour, type } = productData;
  const {
    VC_FULL_RIM,
    VC_HALF_RIM,
    VC_RIMLESS,
    PRODUCT_OFFERID_CONFIG_DESKTOP,
    SHOW_DELIVERY,
    ENABLE_POSTPAY_WIDGET,
  } = redisCommonData || {};
  const currencyCode =
    productData.prices && productData.prices.length > 0
      ? productData.prices[0].currencyCode
      : dataLocale.CURRENCY_CODE;
  const currencySymbol = <span>{currencyMark[currencyCode]}</span>;
  const { DELIVERY_CONTACT_LENSES, DELIVERY_FRAME, OPEN_BRACKET, CLOSE_BRACKET, WITH_GST, } = dataLocale;
  const productSpecification = productData?.specifications;
  const productGeneralInfo = productSpecification && productSpecification[0].items;
  const frameSizeData =
    productGeneralInfo && productGeneralInfo.find(info => info.name === 'Frame Size');
  const checkFaceWidthUrl = frameSizeData?.urlDetails?.url;
  let visitorProductValue =
    productData.prices[1] !== undefined && productData.prices[1] !== null
      ? productData.prices[1].price
      : '';
  let isShortListed = false;
  // let vcDifferentPrice = false;
  const techinalInformation =
    productData !== undefined && productData !== null ? productData.specifications[1].items : '';
  let ftype = null;
  // Frame Type Check
  if (techinalInformation) {
    techinalInformation.map(value => {
      if (value.name === 'Frame Type') {
        ftype = value.value.toLowerCase();
      }
      return ftype;
    });
  }
  if (productData.prices.length === 3) {
    visitorProductValue = productData.prices[2].price;
    if (productData.brandName === 'Vincent Chase' && productData.type === 'Eyeglasses') {
      if (ftype === 'full rim') {
        if (VC_FULL_RIM) {
          visitorProductValue = VC_FULL_RIM;
        }
        // vcDifferentPrice = true;
      } else if (ftype === 'half rim') {
        if (VC_HALF_RIM) {
          visitorProductValue = VC_HALF_RIM;
        }
        // vcDifferentPrice = true;
      } else if (ftype === 'rimless') {
        if (VC_RIMLESS) {
          visitorProductValue = VC_RIMLESS;
        }
        // vcDifferentPrice = true;
      }
    }
  }
  if (shortListData && shortListData.result.productList) {
    isShortListed = shortListData.result.productList.some(shortListProduct => {
      if (productId === shortListProduct.id) {
        return true;
      }
      return false;
    });
  }
  let subSelection = 'default';
  if (login) {
    subSelection = userInfo?.result?.hasPlacedOrder ? 'repeat' : 'new';
  }
  const productOfferIdDetails =
    PRODUCT_OFFERID_CONFIG_DESKTOP &&
    PRODUCT_OFFERID_CONFIG_DESKTOP[productData.offerName] &&
    PRODUCT_OFFERID_CONFIG_DESKTOP[productData.offerName][subSelection];

  return (
    <div className="product-details">
      <div className="layout justify-content-between align-items-start">
        <div aria-label="product name" className="width85">
          {productData.brandName && (
            <h2 className="product-brands capitalize text-color-grey">{productData.brandName}</h2>
          )}
          {productData.classification === 'eyeframe' ||
          productData.classification === 'sunglasses' ? (
            <h1
              className="capitalize fs16 padding-t10 padding-b10 product-fullName"
              id="productName"
            >
              {frameColour} {frameType} {frameShape} {type}
            </h1>
          ) : (
            <h1
              className="capitalize fs16 padding-t10 padding-b10 product-fullName"
              id="productName"
            >
              {productData.fullName} {contactLensPowerFromUrl}
            </h1>
          )}
        </div>
        <div className="align-items-start layout">
          <div
            aria-label="shortlist btn"
            className={shortListLoading ? 'disabled-shortlist' : ''}
            onClick={ev => setWishListCallLeft(props, ev)}
          >
            <span
              className={`cursor-pointer text-center fa fs25 shortlist-icon ${
                !isShortListed ? 'fa-heart-o text-color-black' : 'fa-heart text-color-red'
              }`}
              data-testid="shortlistIcon"
              title={isShortListed ? 'Shortlisted Product' : 'Shortlist Product'}
            ></span>
          </div>
        </div>
      </div>
      {frameSize && (
        <FrameAnalysis
          checkFaceWidthUrl={checkFaceWidthUrl}
          cmsPopUpData={cmsPopUpData}
          dataLocale={dataLocale}
          frameSize={frameSize}
          getCmsPageData={getCmsPageData}
          localeInfo={localeInfo}
        />
      )}
      <div aria-label="product price">
        <span className="price fs22 color-green nowrap fw-bold" id="lenskartPrice">
          {productOfferIdDetails && productOfferIdDetails.text1 && !isExchange
            ? `${productOfferIdDetails.text1} `
            : ''}
          {currencySymbol}
          {visitorProductValue}
        </span>
        {productData.prices[0].price > visitorProductValue && (
          <span className="text-light-gray fw500 fs15" id="marketPrice">
            <s className="padding-l5">
              {currencySymbol}
              {productData.prices[0].price}
            </s>
          </span>
        )}
        {productPriceWithGst && (
          <span className="fw500 fs11" id="marketPrice">
            <span className="padding-l5">
              {OPEN_BRACKET}
              {currencySymbol}
              {productPriceWithGst} {WITH_GST}
              {CLOSE_BRACKET}
            </span>
          </span>
        )}
      </div>
      {/* Postpay PDP widget */}
      {ENABLE_POSTPAY_WIDGET === 'ON' && (
        <div
          className="postpay-widget"
          data-amount={Number(displayPrice) * 100}
          data-currency={currencyMark[currencyCode]}
          data-locale="en"
          data-num-instalments={3}
          data-type="product"
        ></div>
      )}
      {isExchange && (
        <div className="mr-b4">
          <span className="exchange-price text-color-primary fw500 mr-t5 fsp9 lh-11 bora-4">
            {displayPrice > 0 ? exchangeText : exchangeFreeText}
          </span>
        </div>
      )}
      {productData.classification === 'eyeframe' && (
        <div className="fs14 lh-12">{dataLocale.FRAME_PLUS_LENS}</div>
      )}
      {productData?.colorOptions &&
        productData?.colorOptions.length > 0 &&
        productData?.colorOptions[0].color && (
          <ColorOptions
            history={history}
            localeInfo={localeInfo}
            product={productData}
            redisCommonData={props.redisCommonData}
          />
        )}
      {SHOW_DELIVERY && (
        <div className="Delivery fs12 lh-12">
          {productData.classification === 'contact_lens' ? DELIVERY_CONTACT_LENSES : DELIVERY_FRAME}
        </div>
      )}
    </div>
  );
}

export default ProductDetailNew;
